(function($) {
  "use strict";
  jQuery(document).ready(function(){
    /* jQuery MeanMenu */
    $('#mobile-menu-active').meanmenu({
      meanScreenWidth: "991",
      meanMenuContainer: ".mobile-menu-area .mobile-menu",
    });

    /*====== sidebarCart ======*/
    function sidebarCart() {
      var menuTrigger = $('button.sidebar-trigger'),
          endTrigger = $('button.op-sidebar-close'),
          container = $('.sidebar-cart'),
          wrapper = $('.wrapper');
      wrapper.prepend('<div class="body-overlay"></div>');
      menuTrigger.on('click', function() {
        container.addClass('inside');
        wrapper.addClass('overlay-active');
      });
      endTrigger.on('click', function() {
        container.removeClass('inside');
        wrapper.removeClass('overlay-active');
      });
      $('.body-overlay').on('click', function() {
        container.removeClass('inside');
        wrapper.removeClass('overlay-active');
      });
    };
    sidebarCart();


    /*====== sidebarSearch ======*/
    function sidebarSearch() {
      var searchTrigger = $('button.sidebar-trigger-search'),
          endTriggersearch = $('button.search-close'),
          container = $('.main-search-active');
      searchTrigger.on('click', function() {
        container.addClass('inside');
      });
      endTriggersearch.on('click', function() {
        container.removeClass('inside');
      });
    };
    sidebarSearch();

    
    

    $("[data-toggle=tooltip]").tooltip();

    /* expand menu */
    $('.icon_menu').on('click', function () {
      $('.menu-expand').slideToggle(400)
      $(".icon_close").on('click',function () {
        $(".menu-expand").slideUp("slow");

      });
    });



    $('.product-dec-slider').owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout: 5000,
        nav: true,
        navText: ['<i class="ti-angle-left"></i>', '<i class="ti-angle-right"></i>'],
        item: 4,
        margin: 12,
        responsive: {
            0: {
                items: 2
            },
            768: {
                items: 4
            },
            1000: {
                items: 4
            }
        }
    })
    
    

    /*------ Wow Active ----*/
    new WOW().init();

    /*--
    Menu Stick
    -----------------------------------*/
    var header = $('.transparent-bar');
    var win = $(window);

    win.on('scroll', function() {
      var scroll = win.scrollTop();
      if (scroll < 200) {
        header.removeClass('stick');
      } else {
        header.addClass('stick');
      }
    });


    /* Button Effect */
    function buttonEffect() {
      $('<b></b>').appendTo('.cr-btn');
      $('.cr-btn')
      .on('mouseenter', function(e) {
        var parentOffset = $(this).offset(),
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        $(this).find('b').css({
          top: relY,
          left: relX
        });
      })
      .on('mouseout', function(e) {
        var parentOffset = $(this).offset(),
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        $(this).find('b').css({
          top: relY,
          left: relX
        });
      });
      $('[href="#"]').on('click',function() {
        return true;
      });
    }
    buttonEffect();


    /* creative-menu-6 */
    var CreativeMenu = $('.sidebarmenu-wrapper');
    $(".menu-icon").on("click", function() {
      CreativeMenu.css('left', '0').addClass('animated Toggle');
    })
    $(".menu-close").on("click", function() {
      CreativeMenu.css('left', '-420px').removeClass('animated Toggle');
    })


    /* Sidemenu Dropdown */
    function sidemenuDropdown() {
      var $this = $('.sidebarmenu-wrapper');
      $this.find('nav.menu .cr-dropdown')
      .find('ul').slideUp();
      $this.find('nav.menu li.cr-dropdown > a, nav.menu li.cr-sub-dropdown > a').on('click', function(e) {
        e.preventDefault();
        $(this).next().slideToggle();
      });
    }
    sidemenuDropdown();


    /*---------------------
    shop grid list
    --------------------- */
    $('.view-mode li a').on('click', function() {
      var $proStyle = $(this).data('view');
      $('.view-mode li').removeClass('active');
      $(this).parent('li').addClass('active');
      $('.product-view').removeClass('product-grid product-list').addClass($proStyle);
    })


    /*-- Price Range --*/
    $('#price-range').slider({
      range: true,
      min: 0,
      max: 700,
      values: [70, 500],
      slide: function(event, ui) {
        $('.price-amount').val('$' + ui.values[0] + ' - $' + ui.values[1]);
      }
    });
    $('.price-amount').val('$' + $('#price-range').slider('values', 0) +
                           ' - $' + $('#price-range').slider('values', 1));
    $('.product-filter-toggle').on('click', function() {
      $('.product-filter-wrapper').slideToggle();
    })


    // Instantiate EasyZoom instances
    var $easyzoom = $('.easyzoom').easyZoom();

    /*------------------------------ 
       Toggle Function Active
   ---------------------------------*/
    /*--- showlogin toggle function ----*/
    $('#showlogin').on('click', function () {
      $('#checkout-login').slideToggle(900);
    });

    /*--- showlogin toggle function ----*/
    $('#showcoupon').on('click', function () {
      $('#checkout_coupon').slideToggle(900);
    });
    /*--- showlogin toggle function ----*/
    $('#cbox').on('click', function () {
      $('#cbox-info').slideToggle(900);
    });

    /*--- showlogin toggle function ----*/
    $('#ship-box').on('click', function () {
      $('#ship-box-info').slideToggle(1000);
    });

    /*---------------------
    sidebar sticky
    --------------------- */
    $('.sidebar-active').stickySidebar({
      topSpacing: 80,
      bottomSpacing: 30,
      minWidth: 991,
    });


    /* isotop active */
    // filter items on button click
    $('.blog-area').imagesLoaded(function() {
      $('.portfolio-menu-active').on('click', 'button', function() {
        var filterValue = $(this).attr('data-filter');
        $grid.isotope({
          filter: filterValue
        });
      });
      // init Isotope
      var $grid = $('.blog-grid').isotope({
        itemSelector: '.blog-grid-item',
        percentPosition: true,
        masonry: {
          // use outer width of grid-sizer for columnWidth
          columnWidth: '.blog-grid-item',
        }
      });
    });

 


    /* CounterUp Active */
    $('.counter').counterUp({
      delay: 10,
      time: 1000
    });

    /*--
        Isotop with ImagesLoaded
    -----------------------------------*/
    var isotopFilter = $('.isotop-filter');
    var isotopGrid = $('.isotop-grid');
    var isotopGridMasonry = $('.isotop-grid-masonry');
    var isotopGridItem = '.isotop-item';
    /*-- Images Loaded --*/
    isotopGrid.imagesLoaded(function () {
      /*-- Filter List --*/
      isotopFilter.on('click', 'button', function () {
        isotopFilter.find('button').removeClass('active');
        $(this).addClass('active');
        var filterValue = $(this).attr('data-filter');
        isotopGrid.isotope({ filter: filterValue });
      });
      /*-- Filter Grid Layout FitRows --*/
      isotopGrid.isotope({
        itemSelector: isotopGridItem,
        layoutMode: 'fitRows',
        masonry: {
          columnWidth: 1,
        }
      });
      /*-- Filter Grid Layout Masonary --*/
      isotopGridMasonry.isotope({
        itemSelector: isotopGridItem,
        layoutMode: 'masonry',
        masonry: {
          columnWidth: 1,
        }
      });
    });


    /*--
        Magnific Popup
    -----------------------------------*/
    /*-- Video --*/
    var videoPopup = $('.video-popup');
    videoPopup.magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      zoom: {
        enabled: true,
      }
    });
    /*-- Image --*/
    var imagePopup = $('.image-popup');
    imagePopup.magnificPopup({
      type: 'image',
    });
    /*-- Gallery --*/
    var galleryPopup = $('.gallery-popup');
    galleryPopup.magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });
    /*-- Gallery Video --*/
    var videGalleryPopup = $('.video-gallery-popup');
    videGalleryPopup.magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      zoom: {
        enabled: true,
      },
      gallery: {
        enabled: true
      }
    });

    /*--------------------------
     ScrollUp
    ---------------------------- */
    $.scrollUp({
      scrollText: '<i class="ion-arrow-up-c"></i>',
      easingType: 'linear',
      scrollSpeed: 900,
      animation: 'fade'
    });

  });
})(jQuery);